import { styled } from 'solid-styled-components';
import theme from '../../style/theme';

export const StyledInfoBox = styled.div<{ withoutPadding?: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.75rem;

    padding: ${p => p.withoutPadding ? '0' : '1.5rem'};
    background: ${theme.palette.lightBeige};
    border-radius: 1.43rem;
    font-size: 1rem;
`;